import React from "react";

/**
 * Represents properties for managing the visibility of child components.
 *
 * This interface defines the structure for controlling whether UI elements
 * should be visibly rendered, allowing developers to conditionally toggle
 * their display status.
 */
export interface VisibilityHandlerProps {
    isVisible: boolean
    children: React.ReactNode | React.ReactNode[]
}

/**
 * Controls the visibility of its child components based on a provided condition.
 *
 * This function ensures that its children are only rendered if the 'isVisible' condition is met.
 * It is useful for managing conditional rendering scenarios in a React component tree.
 *
 * @param isVisible - A boolean indicating whether the child components should be rendered. If false, nothing will be rendered.
 * @param children - The React child components to be conditionally rendered.
 * @return The rendered child components when 'isVisible' is true; otherwise, returns null.
 */
export function VisibilityHandler({ isVisible, children }: VisibilityHandlerProps ) {
    if( ! isVisible ) {
        return null;
    }

    return (
        <>
            { children }
        </>
    );
};